<template lang="pug">
    v-container( fluid )
        v-form( ref="form" v-model="valid" lazy-validation )
            v-layout( row wrap )
                v-flex( xs12 )
                    v-autocomplete(
                        v-model='branchOfficeSelected'
                        :items='branchOffice'
                        item-text='type'
                        item-value='id'
                        placeholder='Seleccione parámetros a buscar'
                        single-line 
                        outline 
                    )
                        div.formLabel( slot='prepend' ) Sucursal
                v-flex( xs12 )
                    v-divider.mb-4.pb-1
                v-flex(md6)
                
                    v-autocomplete.mx-3(
                        v-model = 'selectedFamily'
                        :items = 'familyList'
                        item-text = 'family'
                        item-value = 'id'
                        placeholder = 'Seleccione Familia (opcional)'
                        single-line 
                        outline 
                    )
                        div.formLabel(slot='prepend')
                            | Familia
                v-flex(md6)
                    v-autocomplete.mx-3(
                        v-model = 'selectedSubfamily'
                        :items = 'subfamilyList'
                        item-text = 'subfamily'
                        item-value = 'id'
                        placeholder = 'Seleccione SubFamilia (opcional)'
                        single-line 
                        outline 
                    )
                        div.formLabel(slot='prepend')
                            | Subfamilia
                
                v-flex.mt-5(md12 v-if="branchOfficeSelected!=null")
                    v-divider
                    crud-data-table(:service="service" @show="$router.push('/products/'+$event)" :headers="headers" :filters="[]" @select="selected = $event" checkable :editableFieldsOverwrites="testprop")
                v-flex.pa-5(md12 v-if="selected!=null")
                    v-btn(block='' color='secondary' dark='' @click="submitOffers") Guardar Descuentos
</template>

<script>
import CrudDataTable from '@/components/CrudDataTable/CrudDataTable'
import CurrencyUtils from '@/mixins/CurrencyUtils.js'
import {
    getFetchDataFunction,
    generateDeleteItemFunction,
} from '@/services/api/DataTableService'
import productMdl from '@/models/Warehouse/WhProduct'
import FamilyMdl from '@/models/Warehouse/WhFamily'
import SubfamilyMdl from '@/models/Warehouse/WhSubfamily'
import FamilyService from '@/services/api/family/FamilyServices' //TODO: delete final s 
import SubfamilyService from '@/services/api/subfamily/SubfamilyService'
import saleUtils from '@/services/SaleUtils'
import offerService from '@/services/api/offer/OfferService'
import {mapActions} from 'vuex'
const route = process.env.VUE_APP_API_ROUTE + '/wh_product?g_branch_office_id=1'

//

export default {
    name: 'offer-create',
    props: {},
    data: function() {
        return {
            /**
             * 
             * 
             */
            listBranches: [],
            selectedBranch: null,

            /**
             * 
             * 
             */
            branchOffice:[
                { id: 1 , type: 'La serena'},
                { id:2 , type: 'ovalle'}
            ],
            branchOfficeSelected:null,
            service:{
                dtFetchData:{}
            },
            selected:null,
            date: null,
            dateFormatted: null,
            menu1:false,
            date2: null,
            dateFormatted2: null,
            menu2:false,
            familyList:[],
            selectedFamily:null,
            subfamilyList:[],
            selectedSubfamily:null,
            generalDiscount:'',
            testprop:[{
                field: 'virtual_offer_price',
                    value: 0,
                    condition: row => {
                        if(row.virtual_offer_price === null) return true
                        return false
                    }
            }],
            headers:[
                {
                    text: 'UPC',
                    align: 'left',
                    sortable: 'false',
                    fieldType: 'computed',
                    computed: (row) => {
                        return row.wh_product_upc_code[0].upc_code || '-'
                    },
                    editable: false,
                    width: null,
                },
                {
                    text: 'ID',
                    align: 'left',
                    sortable: 'false',
                    value: 'id',
                    editable: false,
                    width: null,
                },
                {
                    text: 'COD INTERNO',
                    align: 'left',
                    sortable: 'false',
                    value: 'internal_code',
                    editable: false,
                    width: null,
                },
                {
                    text: 'NOMBRE',
                    align: 'left',
                    sortable: 'false',
                    value: 'name',
                    fieldType: 'text',
                    fieldOptions: {
                        color: 'red',
                    },
                    width: '1000px',
                },
                {
                    text: 'CONSUMIBLE',
                    align: 'left',
                    sortable: 'false',
                    value: 'is_consumable',
                    editable: false,
                    width: null,
                },
                {
                    text: 'PRECIO VENTA',
                    align: 'left',
                    sortable: 'false',
                    value: 'sale_price_by_branch_office',
                    editable: false,
                    width: null,
                    format: 'currency'
                },
                {
                    text: 'NUEVO PRECIO VENTA',
                    align: 'left',
                    sortable: 'false',
                    value: 'virtual_sale_price',
                    fieldType: 'text',
                    fieldProps: {                        
                        prefix: '$'
                    },
                    format: [ 'currency' ],
                    editable: true,
                    width: null,
                },
                /**{
                    text: 'NUEVO PRECIO',
                    align: 'left',
                    sortable: 'false',
                    value: 'price',
                    fieldType: 'computed',
                    
                    editable: false,
                    computed: (item) => {
                        return '$' + saleUtils.priceWithDiscount(item.sale_price_by_branch_office, item.virtual_offer_price).toLocaleString('es')
                    },
                    width: null,
                },*/
            ],
            valid :true,
            rules: [
                v => !!v || 'Campo requerido',
            ],
            showTable:false,
            offerName:null,
            
        }
    },
    computed: {},
    methods: {
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        parseDate (date) {
            if (!date) return null

            const [month, day, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        async submitOffers(){

            if (this.$refs.form.validate()) {
                let whProducts = []
                this.selected.forEach((item,index)=>{
                    let obj={}
                    obj.id = item.id
                    obj.offer_price = saleUtils.priceWithDiscount(item.sale_price_by_branch_office, item.virtual_offer_price)
                    if(obj.offer_price<item.sale_price_by_branch_office && obj!={}){
                        whProducts[index] = obj
                    } 

                    console.log( item )
                })
                let payload = {}
                payload.whProducts = whProducts
                payload.offerName = this.offerName
                payload.branchOffice = 1
                payload.initOffer = this.date
                payload.finishOffer = this.date2
                /*
                let response = await offerService.sendNewOffer(payload)
                if(response.status=201){
                    this.resetSnackbarState()
                    let snackInfo = this.fillSnack('success','Éxito' ,'Los precios de oferta fueron asignados correctamente',false,3000)
                    this.initSnackbar(snackInfo)
                }
                else{
                    this.resetSnackbarState()
                    let snackInfo = this.fillSnack('error','Error' ,response,false)
                    this.initSnackbar(snackInfo)
                }*/
            }else{
                this.resetSnackbarState()
                let snackInfo = this.fillSnack('error','Error' ,'Se han detectado campos sin validar',false)
                this.initSnackbar(snackInfo)
            }  
        },
    },
    watch: {
        date (val) {
            this.dateFormatted = this.formatDate(this.date)
        },
        date2(val){
            this.dateFormatted2 = this.formatDate(this.date2)
        },
        selected:function(val){
            
        },
        generalDiscount(val){
            this.testprop[0].value = val
        },
        branchOfficeSelected( val ) {
            //
            let append = [ 'sale_prices', 'sale_price_by_branch_office', 'virtual_offer_price' ]

            //
            this.service.dtFetchData = getFetchDataFunction(route , ['wh_product_upc_code'], append, null)
        },
        async selectedFamily(val){
            this.subfamilyList = await SubfamilyService.fetchAllSubfamilyByFamilyId(val)
            this.service.dtFetchData = getFetchDataFunction(route + '&filter[wh_family_id]=' + val , ['wh_product_upc_code'], ['sale_price_by_branch_office','virtual_offer_price'], null)
        },
        selectedSubfamily(val){
            this.service.dtFetchData = getFetchDataFunction(route + '&filter[wh_subfamily_id]=' + val, ['wh_product_upc_code'], [ 'sale_price_by_branch_office','virtual_offer_price' ], null)
            console.log(this.service)
        }

    },
    components: {
        'crud-data-table': CrudDataTable,
    },
    mixins: [ 
        CurrencyUtils, 
    ],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    mounted: async function(){
        this.setTitleTopBar( 'Modificar precio de venta' )
        let family = await FamilyService.fetchAllFamily()
        this.familyList = family
        
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
.formLabel {
    font-weight: bold;
    min-width: 150px;
    max-width: 150px;
    font-size: 20px;
}
.crud-area{
    min-height: calc(100vh - 65px);
}
</style>